import React, {Component, Fragment} from 'react'
import './style.scss'
import ReactPlayer from 'react-player'
import { Form, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import logo from '../../images/Logos/vertical_odin_logo.png'
import FeatureSection from 'components/Shared/FeatureSection/FeatureSection'
import { device, browser } from 'utils/utils'
import { isEmpty, toLower, toUpper } from 'lodash'
// import moneyIcon from 'images/money.png'
// import medalIcon from 'images/medal.png'
import { codeDiscount } from 'actions/subscription.actions'
import { AFFILIATE_CODES } from 'config/constants'
import { userSubscriptionInvalid, revertCodeSubscribe } from 'utils/utils'
import queryString from 'query-string'
import { toast } from 'react-toastify'
import { notify } from 'utils/utils'
import loadable from '@loadable/component'
import discordLogo from 'images/Logos/discord_logo_white.svg'
import promotion66Percent from 'images/promotion-66-percent.png'

const CheckInfoPopup = loadable(() => import('components/SubscriptionPage/BillingCyclePopup/CheckInfoPopup/CheckInfoPopup.jsx'))
const SubcribePageSection = loadable(() => import('components/SubscriptionPage/component'))

class CLandingPage extends Component {

  constructor(props) {
    super(props)

    this.state = {
      notify: {
        text: '',
        color: '',
        isValidEmail: false,
      },
      firstVideo: {
        play: true,
        volume: 0.2,
        url: 'https://youtu.be/d8T7ZphP86I'
      },
      secondVideo: {
        play: false,
        url: 'https://www.youtube.com/watch?v=LOBU3UX88Fw'
      },
      emailValue: '',
      checkInfoPopup: {
        selectedPlan: '',
        code: '',
        showing: false,
      }
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.handleChangeEmail = this.handleChangeEmail.bind(this)
    this.handleClickStarted = this.handleClickStarted.bind(this);
    this.handleShowCheckInfoPopup = this.handleShowCheckInfoPopup.bind(this)
  }

  componentDidMount() {
    const { currentUser, history } = this.props
    const { location } = history
    const params =  queryString.parse(location.search)
    const t = this.context.t

    if(Object.keys(params) && params['accepted_auto_renew_status']) {
      if(params['accepted_auto_renew_status'] === 'success')
        notify(t('toast.accepted_auto_renew_success'), toast.success)
      else if(params['accepted_auto_renew_status'] === 'failed')
        notify(t('toast.accepted_auto_renew_failed'), toast.info)
      else
        notify(t('toast.accepted_auto_renew_something_wrong'), toast.error)
      history.replace('/')
    }

    if (!isEmpty(location.state) && location.state.firstSignin && !userSubscriptionInvalid(currentUser.attributes)) {
        history.push('/strategy-select', {login: true})
    } else {
      const { pathname } = this.props.location
      const code = revertCodeSubscribe(toLower(pathname))
      if (AFFILIATE_CODES.includes(code)) {
        this.props.updateDiscountCode(code)
        localStorage.setItem('code', code)
      } else {
        this.props.updateDiscountCode('')
        localStorage.removeItem('code')
      }
      const publicIp = require('public-ip');
      (async () => {
        if (!isEmpty(this.props.currentUser.attributes)) {
          const payload = {
            current_ip_v4: await publicIp.v4(),
            device: device(),
            browser: browser(),
            online: true
          }
          this.infoAfterLogin(payload)
        }
      })();
    }
  }

  removeKey = (e) =>  {
    e.preventDefault();
    if (!isEmpty(this.props.currentUser.attributes))
      this.infoAfterLogin({ online: false })
    localStorage.removeItem('first-sign-in')
  }

  infoAfterLogin(payload) {
    const { attributes: user } = this.props.currentUser
    window.axios.put(`/users/${user.id}/update_info_current_login`, payload)
    .then( res => { }).catch(error => { })
  }



  handleChangeEmail(e) {
    if(!!this.state.notify.text) this.setState({notify: {}})
    this.setState({ emailValue: e.currentTarget.value })
  }

  renderForm() {
    let t = this.context.t

    return <Form
      inline
      onSubmit={this.onSubmit}
      className='subscribe-form'
    >
      <Form.Control
        onChange={this.handleChangeEmail}
        value={this.state.emailValue}
        name='email'
        type="text"
        placeholder={t('email_placeholder')}
        className='col-sm-9'
      />
      <Button type='submit' className='btn-primary col-sm-3' >
        {t('landing_page.subscribe')}
      </Button>
    </Form>
  }

  onSubmit(e){
    //send information
    e.preventDefault()
    const t = this.context.t
    const { emailValue } = this.state
    if(!emailValue) {
      this.setState({notify: {text: t('required_field') , color: 'text-danger', isValidEmail: false}})
    }
    else {
      window.axios.post('/subscribers', { subscriber: {email: emailValue} })
      .then( res => {
        if(!!res.data.error_message) {
          this.setState({notify: {text: res.data.error_message , color: 'text-danger', isValidEmail: false}})
          return
        }

        this.setState({notify: {
          text: `You have successfully subscribed for email ${res.data.subscriber.email}`,
          color: 'text-success', isValidEmail: true
        }})
        setTimeout(() => this.setState({notify: {}}) ,5000)
      })
      .catch( err => { console.log(err) })
    }
  }

  handleClickStarted() {
    this.props.history.push('/subscribe');
  }

  renderLandingViewAdmin() {
    const t = this.context.t
    const { color, text } = this.state.notify
    return (
     <div className='landing-page padding-content'>
        <div className='logo-image text-center'>
          <img alt='logo' className='logo w-100' src={logo}/>
          <p className='text-white text-center title'> {t('landing_page.comming_soon')} </p>
        </div>
        <FeatureSection className='mr-top-100' />
        <div className='subcribe-box'>
          <p className='description'>
            {t('landing_page.first')} <br />
            {t('landing_page.second')}
          </p>
          {this.renderForm()}
          <label className={`${color} mt-2`}> {text} </label>
        </div>
      </div>
    )
  }

  handleShowCheckInfoPopup() {
    this.setState({checkInfoPopup: {...this.state.checkInfoPopup, showing: !this.state.checkInfoPopup.showing} })
  }

  joinDiscordBtn(t){
    return (
      <div className='p-0 join-discord-container'>
        <a href={t('contact.discord_link')} target='blank' className='join-discord text-primary-color text-decoration-none'>
          <div className="discord-logo-container mr-3">
            <img src={discordLogo} alt='discord-logo' className='h-100 discord-logo' />
          </div>
          JOIN OUR DISCORD
        </a>
      </div>
    )
  }

  renderViewNormal() {
    const t = this.context.t
    const { secondVideo, checkInfoPopup: {showing: showCheckInfoPopup, code: checkoutCode, selectedPlan}  } = this.state
    const { isSignedIn, attributes: { emailConfirmed, subscription } } = this.props.currentUser
    const userSignedIn = isSignedIn && emailConfirmed && !isEmpty(localStorage.getItem('access-token'))
    const isChangeSubscriptionView = subscription && (subscription.status === 'active' || subscription.status === 'canceled')

    return (
      <Fragment>
        <div className='landing-page'>
          <div className='introduce-section'>
            <div className='padding-content'>
              <div className='title-top'>
                <div className='main-title'>SOLVING POKER </div>
                <div className='main-title'>HAS NEVER BEEN FASTER</div>
                <div className='mt-4 sale-view'>
                  {!userSignedIn &&
                    <div className='try-odin-view'>
                      <Link to={'/signup'} >
                        <Button className='try-odin' >
                          {toUpper(t('landing_page.title_try_odin'))}
                        </Button>
                      </Link>
                    </div>
                  }
                  {this.joinDiscordBtn(t)}
                </div>
              </div>
              <div className='main-event-image'>
                <img src={promotion66Percent} alt='event'/>
              </div>
            </div>
          </div>
          <div className='padding-content'>
            <div className='mr-top-100 justify-content-center view-comments'>
              {/* <Row className='view-comments-second'>
                <Col sm={5}>
                  <div className="view-odin-second"></div>
                </Col>
                <Col sm={7} className='d-flex flex-column-reverse'>
                  <div>
                    <div className="dot-icon"></div>
                    <div className="view-conversation">
                      <p className="mt-2 conversation-content">Odin gives you the ability to study basically any spot without ever touching a solver. The quality is by far the best I’ve ever seen. I think it’s a must have for anyone who wants to reach the next level in poker.</p>
                      <div className="bottom-conversation">
                        <p className="mb-0 color-name">Fedor Holz</p>
                        <div className='d-flex'><img src={moneyIcon} alt=''/><p className="mb-0 color-desc">$30m+ in live earnings</p></div>
                        <div className='d-flex'><img src={medalIcon} alt=''/><p className="mb-0 color-desc">2x WSOP Gold Bracelet winner.</p></div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row> */}
            </div>
            <div className="play-video">
              <div className='video-title'> {t('landing_page.what_is_odin')} </div>
              <ReactPlayer
                className='react-player w-100'
                width={100}
                url={secondVideo.url}
                playing={secondVideo.play}
                controls={true}
              />
            </div>
            <div className="compare-section">
              <div className="title-the-best mt-5 mb-5">Why are we the best?</div>
              <div className="features-table mx-auto"></div>
            </div>
          </div>
          <div className="landing-page-subscribe">
            <SubcribePageSection
              history={this.props.history}
              isPartOfLandingPage={false}
              isChangeSubscriptionView={isChangeSubscriptionView}
            />
          </div>
        </div>
        <CheckInfoPopup
          show={showCheckInfoPopup}
          selectedPlan={selectedPlan}
          code={checkoutCode}
          handleShowCheckInfoPopup={this.handleShowCheckInfoPopup}
        />
      </Fragment>
    )
  }

  render() {
    return this.renderViewNormal()
  }
}

CLandingPage.contextTypes = {
  t : PropTypes.func
}

const mapStoreToProps = (store) => ({
  i18nState: store.i18nState,
  currentUser: store.reduxTokenAuth.currentUser,
  subscriptions: store.subscriptions
})

const mapDispatchToProps = {
  updateDiscountCode: codeDiscount
}

export default connect(
  mapStoreToProps,
  mapDispatchToProps
)(CLandingPage)
